export default "__VITE_ASSET__Bu89LjOe__"